import React from "react";
import { useSelector } from "react-redux";
import GlobalDeleteDialog from "../../components/mui/Dialogue/GlobalDeleteDialog";
import {
  deleteEditRequest,
  getCartEditRequests,
} from "../../redux/features/generalSlice";

const DeleteEditrequest = ({ requestId, dispatchParams,row }) => {
  const { loading } = useSelector((state) => state.general);
  const { paginationData, openAnchor } = useSelector(
    (state) => state.globalDataGrid
  );

  return (
    <GlobalDeleteDialog
      title={"Delete Request"}
      deleteNote={"Are you sure? you want to delete this request?"}
      api={deleteEditRequest(requestId)}
      upDateCall={getCartEditRequests(dispatchParams)}
      loading={loading}
      disabled={!row.requestEditable}
    />
  );
};

export default DeleteEditrequest;
